import URI from "urijs";

import { ReadableUploadSource } from "../../base-types";
import { IUploadSource } from "../../contracts/upload/upload-source";

export class LocalUploadSource implements IUploadSource {
    private _uri: URI;

    constructor(path: string, name: string = "") {
        this.ensureNonBrowserEnvironment();

        this._uri = new URI(path);

        if (this._uri.protocol() !== "file") {
            throw new Error("Invalid protocol. Only paths using the file protocol are supported.");
        }

        this.name = name.length > 0 ? name : this._uri.filename();
    }

    name: string;

    async getReadableSourceAsync(): Promise<ReadableUploadSource> {
        this.ensureNonBrowserEnvironment();

        const fs = require("fs") as typeof import("fs");

        const buffer = fs.readFileSync(this._uri.path());
        const sliced = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
        return Promise.resolve(sliced as ArrayBuffer);
    }

    // https://github.com/axios/axios/blob/16aa2ce7fa42e7c46407b78966b7521d8e588a72/lib/utils.js#L208-L218
    private isStandardBrowserEnv(): boolean {
        if (
            typeof navigator !== "undefined" &&
            (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")
        ) {
            return false;
        }
        return typeof window !== "undefined" && typeof document !== "undefined";
    }

    private ensureNonBrowserEnvironment(): void {
        if (this.isStandardBrowserEnv()) {
            throw Error("LocalUploadSource is not supported when running in a browser environment.");
        }
    }
}
